import React, { Component } from 'react';
import { getUserChildren, getChildRecordByDocument } from '../../services'
import Select from 'react-select';
import { FormGroup, Col, Label } from 'reactstrap';
import ChildTable from './ChildTable';
import { childDocument, childTableHeader } from '../configData'

class ShareChildRecord extends Component {

  state ={
    dropdownLoading: true,
    children: [],
    childId: null,
    document: null
  }

  async componentDidMount() {
    const res = await getUserChildren();
    const data = res.data.children;
    const children = data.map((child, idx) => {
      return { label: child.name, value: child._id }
    })

    this.setState(prevState => ({
      children: children,
      dropdownLoading: false
    }))
    
  }

  handleChild = (selectedChild) => {
    this.setState(prevState => ({
      childId: selectedChild['value']
    }))
  }

  handleDocument = async (selectedDocument) => {
    const { childId } = this.state;

    let data = {
      child: childId,
      type: selectedDocument['value']

    }
    const response = await getChildRecordByDocument(data);
    this.setState(prevState => ({
      document: selectedDocument['value'],
      records: response.data.records
    }))
  }

  render() {

    const { children, dropdownLoading, childId, document, records } = this.state;

    return (
      <React.Fragment>
        <Col md="4">
          <FormGroup>
            <Label>Select child</Label>
            <Select 
              options={children}
              isLoading={dropdownLoading}
              onChange={this.handleChild}
            />
          </FormGroup>
        </Col>
        {childId !== null && 
          <Col md="4">
            <FormGroup>
              <Label>Select document type</Label>
              <Select 
                options={childDocument}
                onChange={this.handleDocument}
              />
            </FormGroup>
          </Col>
        }
        {document !== null &&
          <Col md="12">
            <ChildTable records={records}/>
          </Col>
        }
      </React.Fragment>
    )
  }
}

export default ShareChildRecord;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/ShareMyRecord/ShareChildRecord.js